import React from 'react';
import { Bot, Plus, Trash2, ChevronDown, ChevronRight } from 'lucide-react';
import Button from './Button';
import TagsEditor from './TagsEditor';

export default function BotRoleEditor({ botRole, onChange }) {
  const [expandedRoles, setExpandedRoles] = React.useState({});
  
  const roles = Array.isArray(botRole) ? botRole : (botRole ? [{ Role: botRole, Use_Count: '0', CL_Time_Zone: '', If_Have_Tags: [], Speach_Settings: '', If_Not_Have_Tags: [] }] : []);

  const addRole = () => {
    const newRoles = [...roles, {
      Role: '',
      Use_Count: '0',
      CL_Time_Zone: '',
      If_Have_Tags: [],
      Speach_Settings: '',
      If_Not_Have_Tags: []
    }];
    onChange(newRoles);
  };

  const updateRole = (index, field, value) => {
    const newRoles = [...roles];
    newRoles[index][field] = value;
    onChange(newRoles);
  };

  const deleteRole = (index) => {
    if (!window.confirm('Удалить роль?')) return;
    const newRoles = roles.filter((_, i) => i !== index);
    onChange(newRoles);
  };

  const toggleExpand = (index) => {
    setExpandedRoles(prev => ({ ...prev, [index]: !prev[index] }));
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-blue-100 rounded-lg">
            <Bot className="text-blue-600" size={24} />
          </div>
          <div>
            <h3 className="text-xl font-semibold text-gray-900">Роли бота</h3>
            <p className="text-sm text-gray-600">Настройте различные роли AI агента в зависимости от тегов и условий</p>
          </div>
        </div>
        <Button onClick={addRole} size="sm">
          <Plus size={16} className="mr-1" />
          Добавить роль
        </Button>
      </div>

      <div className="space-y-4">
        {roles.map((role, index) => (
          <div key={index} className="bg-white border-2 border-gray-200 rounded-xl p-5 shadow-sm hover:shadow-md transition-shadow">
            <div className="flex items-start justify-between mb-4">
              <button
                onClick={() => toggleExpand(index)}
                className="flex items-center gap-2 text-gray-700 hover:text-blue-600 transition-colors"
              >
                {expandedRoles[index] ? <ChevronDown size={20} /> : <ChevronRight size={20} />}
                <span className="font-medium">
                  Роль {index} {role.Role && `- ${role.Role.substring(0, 50)}...`}
                </span>
              </button>
              <button
                onClick={() => deleteRole(index)}
                className="p-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                title="Удалить роль"
              >
                <Trash2 size={18} />
              </button>
            </div>

            {expandedRoles[index] && (
              <div className="space-y-4 pl-7 border-l-2 border-blue-200">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Описание роли
                  </label>
                  <textarea
                    value={role.Role || ''}
                    onChange={(e) => updateRole(index, 'Role', e.target.value)}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                    rows={6}
                    placeholder="Консультант интернет-магазина техники Apple. Мужчина по имени Егор, 26 лет..."
                  />
                  <div className="mt-1 text-xs text-gray-500">
                    {role.Role?.length || 0} символов
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Количество использований
                    </label>
                    <input
                      type="text"
                      value={role.Use_Count || '0'}
                      onChange={(e) => updateRole(index, 'Use_Count', e.target.value)}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                      placeholder="0"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Часовой пояс клиента
                    </label>
                    <input
                      type="text"
                      value={role.CL_Time_Zone || ''}
                      onChange={(e) => updateRole(index, 'CL_Time_Zone', e.target.value)}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                      placeholder="UTC+3"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Настройки речи
                  </label>
                  <textarea
                    value={role.Speach_Settings || ''}
                    onChange={(e) => updateRole(index, 'Speach_Settings', e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                    rows={3}
                    placeholder="Разговорный стиль, коротко. Использует 👌 в подходящих местах..."
                  />
                </div>

                <TagsEditor
                  label="Теги включения (If_Have_Tags)"
                  tags={role.If_Have_Tags || []}
                  onChange={(tags) => updateRole(index, 'If_Have_Tags', tags)}
                />

                <TagsEditor
                  label="Теги исключения (If_Not_Have_Tags)"
                  tags={role.If_Not_Have_Tags || []}
                  onChange={(tags) => updateRole(index, 'If_Not_Have_Tags', tags)}
                />
              </div>
            )}
          </div>
        ))}
      </div>

      {roles.length === 0 && (
        <div className="text-center py-12 text-gray-500">
          <Bot className="mx-auto mb-4 text-gray-400" size={48} />
          <p>Нет ролей. Добавьте первую роль для AI агента.</p>
        </div>
      )}
    </div>
  );
}
